import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { getConditionsFilterConfig } from '../filters/condition';
import { getSizeFilterConfig } from '../filters/size';
import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { getGenderFilterConfig } from '../filters/gender';

const cafeducyclisteFrSizes = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'One Size'];

/**
 * @deprecated Café du Cycliste France (cafeducycliste-fr) has been consolidated into Café du Cycliste (cafeducycliste)
 */
export const cafeducyclisteFrShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig(),
    getSizeFilterConfig({
      sizes: cafeducyclisteFrSizes,
    }),
    getBrandDirectFilterConfig(),
    getGenderFilterConfig(),
  ],
};
